import {Workspace} from "../../API";

export const workspaceToWorkspaceServer = (wsObj: any): Partial<Workspace> => {
    const serverReadyObj = {...wsObj};
    if (typeof wsObj.childIds === 'object') {
        serverReadyObj.childIds = JSON.stringify(wsObj.childIds)
    }
    if (typeof wsObj.archivedIds === 'object') {
        serverReadyObj.archivedIds = JSON.stringify(wsObj.archivedIds)
    }
    if (typeof wsObj.trashedIds === 'object') {
        serverReadyObj.trashedIds = JSON.stringify(wsObj.trashedIds)
    }
    if (typeof wsObj.pinnedIds === 'object') {
        serverReadyObj.pinnedIds = JSON.stringify(wsObj.pinnedIds)
    }
    return serverReadyObj;
}
